import { render, staticRenderFns } from "./onCellDoubleClick-editor.vue?vue&type=template&id=7843412a&scoped=true&"
import script from "./onCellDoubleClick-editor.vue?vue&type=script&lang=js&"
export * from "./onCellDoubleClick-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7843412a",
  null
  
)

export default component.exports